/**
 * Контейнер для вложенных модалок (например «Права» поверх «Управление»).
 * Всегда в конце document.body + z-index с !important — надёжнее, чем полагаться на порядок CSS на проде.
 */
const NESTED_MODAL_ROOT_ID = 'messenger-nested-modal-root';

export function getMessengerNestedModalRoot() {
  if (typeof document === 'undefined') return null;
  let el = document.getElementById(NESTED_MODAL_ROOT_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = NESTED_MODAL_ROOT_ID;
    el.setAttribute('data-messenger-nested-modals', 'true');
    document.body.appendChild(el);
  }
  el.style.setProperty('position', 'fixed', 'important');
  el.style.setProperty('inset', '0', 'important');
  el.style.setProperty('width', '100%', 'important');
  el.style.setProperty('height', '100%', 'important');
  el.style.setProperty('pointer-events', 'none', 'important');
  el.style.setProperty('z-index', '2147483646', 'important');
  el.style.setProperty('isolation', 'isolate', 'important');
  /* Не вызывать appendChild при каждом getElementById — перемещение узла ломает скролл/фокус внутри портала (моб. «Права»). */
  if (el.parentNode !== document.body) {
    document.body.appendChild(el);
  }
  return el;
}
